import { render } from "./CarouselItem.vue?vue&type=template&id=45f3186a"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__